export const getJpdViewsServicePathPrefix = () => {
	return '/gateway/api/jpd';
};
